import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { Container, Button, Modal, Row, Col, Form, Card } from "react-bootstrap";
import {  MdEdit, MdDelete } from "react-icons/md";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from 'react-toastify';

import { Tooltip } from '@mui/material';
import loading from "../../assets/images/common/loading.gif";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import AppDataGrid from "../../components/common/AppDataGrid";
import TextField from "@mui/material/TextField";


const Periods = () => {

    const userData = sessionStorage.getItem('user');
  const userObj = userData ? JSON.parse(userData) : {};
  const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge"];
  const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [periods, setPeriods] = useState([]);
  const [categorys, setCategorys] = useState([]);
  const [editId, setEditId] = useState(null);

  const formSectionRef = useRef(null);

  const [form, setForm] = useState({
    period_id: "",
    category_id: "",
    period_name: "",
    is_active: "A",
    start_time: "",
    end_time: "",
        period_order: ""
  });


  const fetchPeriods = async () => {
    try {
      const response = await axios.post(baseUrl + "/periods/", {
                action: "READ", school_id: userObj.school_id
      });
      setPeriods(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  const fetchCategorys = async () => {
    try {
      const response = await axios.post(baseUrl + "/category/", {
        action: "READ",
                school_id: userObj.school_id
      });
      setCategorys(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    fetchPeriods().finally(() => setIsLoading(false));
    fetchCategorys();
  }, []);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.start_time) {
      toast.error("Start Time is required", { position: "top-right" });
      return;
    }
    if (!form.end_time) {
      toast.error("End Time is required", { position: "top-right" });
      return;
    }

    const formData = {
      period_name: form.period_name || "",
      category_id: form.category_id || "",
      is_active: form.is_active || "A",
      start_time: form.start_time || "",
      end_time: form.end_time || "",
      school_id: userObj.school_id,
      period_order: form.period_order || "",
      action: editId !== null ? "UPDATE" : "CREATE",
        };

        if (editId !== null) {
            formData.period_id = editId;
        }

    try {
            const response = await axios.post(baseUrl + "/periods/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
      });

            if (editId !== null) {
                toast.success("Record updated successfully", { position: "top-right" });
      setEditId(null);
            } else {
                toast.success("Record added successfully", { position: "top-right" });
            }
      setForm({
        period_id: "",
        category_id: "",
        period_name: "",
        is_active: "A",
        start_time: "",
        end_time: "",
                period_order: ""
      });

      fetchPeriods();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;

        if (status === 400 && data.error === "Record already exists.") {
          toast.error("Record already exists.", { position: "top-right" });
        } else if (
          status === 401 &&
          data.error === "Period order already exists for the specified school and category."
        ) {
                    toast.error("Period order already exists for the specified school and category.", {
                        position: "top-right",
                    });
                } 
                else if (
                    status === 402 &&
                    data.error === "Period name is already exists for category."
                ) {
                    toast.error("Period name is already exists for category.", {
                        position: "top-right",
                    });
                } 
                 else if (
                    status === 403 &&
                    data.error === "Time period overlaps with an existing period."
                ) {
                    toast.error("Time period overlaps with an existing period.", {
                        position: "top-right",
                    });
                } 
                else if (
                    status === 404 &&
                    data.error === "Start time cannot be greater than end time."
                ) {
                    toast.error("Start time cannot be greater than end time.", {
                        position: "top-right",
                    });
                } 
                else if (
                    status === 406 &&
                    data.error === "End time should not be equal to start time."
                ) {
                    toast.error("End Time should not be the same as Start Time.", {
                        position: "top-right",
                    });
                } 
                else if (status === 500) {
                    toast.error(
                        "Error submitting data: " + (data.error || error.message),
                        { position: "top-right" }
                    );

                    
        } else {
          toast.error("Unexpected error occurred", { position: "top-right" });
        }
      } else {
                toast.error("Error submitting data: " + error.message, {
                    position: "top-right",
                });
      }
    }
  };

  const handleEditClick = (period_id) => {
        const periodToEdit = periods.find(period => period.period_id === period_id);
        if (periodToEdit) {
    setForm(periodToEdit);
    setEditId(period_id);
            document.getElementById('periodFormSection').scrollIntoView({ behavior: 'smooth' });
        } else {
            console.error(`Period with ID ${period_id} not found.`);
        }
  };

  const handleDeleteClick = async (period_id) => {
        const confirmDelete = window.confirm('Are you sure you want to update the status?');
        if (!confirmDelete) return;

        const requestBody = {
            period_id: period_id,
            action: "DELETE"
        };
        
        try {
            const response = await axios.post(baseUrl + "/periods/", requestBody, {
                headers: {
                    'Content-Type': 'application/json'
                },
            });
      if (response.status < 200 || response.status >= 300) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      toast.success("Record Set to InActive");
      fetchPeriods();
    } catch (error) {
            console.error('Error:', error);
    }
  };

  const formatTime12Hour = (time) => {
    if (!time) return "";
    if (/^\d{1,2}:\d{2} (AM|PM)$/.test(time)) return time;
    const [hoursStr, minutesStr] = time.split(":");
    if (!hoursStr || !minutesStr) return "No Records Found";
    let hours = parseInt(hoursStr, 10);
    const minutes = minutesStr.padStart(2, "0");
    if (isNaN(hours) || isNaN(minutes)) return "No Records Found";
    const amPm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${amPm}`;
  };

  const columns = [
    {
      field: "category_name",
      headerName: "Category",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "period_name",
      headerName: "Period Name",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "start_time",
      headerName: "Start Time",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span>{formatTime12Hour(params.value)}</span>
        </Tooltip>
      ),
    },
    {
      field: "end_time",
      headerName: "End Time",
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span>{formatTime12Hour(params.value)}</span>
        </Tooltip>
      ),
    },
    {
      field: "period_order",
      headerName: "Period Order",
      width: 140,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={String(params.value ?? "")}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    {
      field: "is_active",
      headerName: "Status",
      width: 140,
      sortable: true,
      renderCell: (params) => (
        <Tooltip title={params.value || ""}>
          <span>{params.value}</span>
        </Tooltip>
      ),
    },
    ...(canSubmit
      ? [
          {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            renderCell: (params) =>
              params.row.period_id !== "No records found" ? (
                <div className="tableActions">
                   <Tooltip title="Edit" arrow>
                  <span className="commonActionIcons" onClick={() => handleEditClick(params.row.period_id)}>
                    <MdEdit />
                  </span>
                  </Tooltip>
                   <Tooltip title="Delete" arrow>
                  <span className="commonActionIcons" onClick={() => handleDeleteClick(params.row.period_id)}>
                    <MdDelete />
                  </span>
                  </Tooltip>
                </div>
              ) : null,
          },
        ]
      : []),
  ];

  const searchableColumns = [
    (row) => row.period_name,
    (row) => row.is_active,
    (row) => row.start_time,
    (row) => row.end_time,
    (row) => row.category_name,
  ];

  const filteredRecords = (periods || []).filter((item) =>
    searchableColumns.some((selector) => {
      const value = selector(item);
      const stringValue = String(value || "").toLowerCase().replace(/[-\s]+/g, "");
      const normalizedQuery = searchQuery.toLowerCase().replace(/[-\s]+/g, "");
      return stringValue.includes(normalizedQuery);
    })
  );

  const handleFilterInputChange = (e) => {
    const { id, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  const handleFilterSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      period_name: form.period_name,
      is_active: form.is_active || "A",
      school_id: userObj.school_id,
      action: "FILTER",
    };

    try {
      const response = await axios.post(baseUrl + "/periods/", formData, {
        headers: { "Content-Type": "application/json" },
      });
      setPeriods(response.data || []);
      setShowFilterModal(false);
    } catch (error) {
      console.log("Full error object:", error);
    }
  };

  const handleFilterReset = async (e) => {
    e.preventDefault();
    setForm({ period_name: "" });
    fetchPeriods();
  };

  return (
    <>
      <ToastContainer />
      <h6>Periods</h6>
      <section id="periodFormSection" ref={formSectionRef}>
        <Container fluid>
          <Card>
            <Card.Body  style={{ padding: "2px" }}>
              <form onSubmit={handleSubmit}>
                 <Row>
                  <Col xs={12}>
                    <h6 className="commonSectionTitle">{editId !== null ? "Edit Period" : "Add New Period"}</h6>
                  </Col>
                </Row> 
                <Row>
                  <Col xs={12} md={6} lg={4} xxl={2}>
                    <div className="commonInput">
                      <Form.Group>
                        <Form.Label>
                          Category<span className="requiredStar">*</span>
                        </Form.Label>
                        <Form.Select id="category_id" required value={form.category_id} onChange={handleInputChange}>
                          <option value="" disabled hidden>Select Category</option>
                          {(categorys || [])
                            .filter((c) => c?.is_active === "Active")
                            .map((c) => (
                              <option key={c.category_id} value={c.category_id}>
                                {c.category_name}
                              </option>
                            ))}
                        </Form.Select>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col xs={12} md={6} lg={4} xxl={2}>
                    <div className="commonInput">
                      <Form.Group>
                        <Form.Label>
                          Period Name <span className="requiredStar">*</span>
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          id="period_name"
                          value={form.period_name}
                          placeholder="Enter Period Name"
                          maxLength={30}
                          onChange={(e) => {
                            const validValue = e.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
                            handleInputChange({ target: { id: "period_name", value: validValue } });
                          }}
                        />
                      </Form.Group>
                    </div>
                  </Col>

                  <Col xs={12} md={6} lg={4} xxl={2}>
                    <div className="commonInput">
                      <Form.Group>
                        <Form.Label>
                          Start Time <span className="requiredStar">*</span>
                        </Form.Label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={form.start_time ? dayjs(form.start_time, "hh:mm A") : null}
                            onChange={(time) =>
                              setForm((prev) => ({ ...prev, start_time: time ? time.format("hh:mm A") : "" }))
                            }
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                          />
                        </LocalizationProvider>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col xs={12} md={6} lg={4} xxl={2}>
                    <div className="commonInput">
                      <Form.Group>
                        <Form.Label>
                          End Time <span className="requiredStar">*</span>
                        </Form.Label>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={form.end_time ? dayjs(form.end_time, "hh:mm A") : null}
                            onChange={(time) =>
                              setForm((prev) => ({ ...prev, end_time: time ? time.format("hh:mm A") : "" }))
                            }
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                          />
                        </LocalizationProvider>
                      </Form.Group>
                    </div>
                  </Col>

                  <Col xs={12} md={6} lg={4} xxl={2}>
                    <div className="commonInput">
                      <Form.Group controlId="periodOrder">
                        <Form.Label>
                          Period Order<span className="requiredStar">*</span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          id="period_order"
                          value={form.period_order}
                          placeholder="Enter Period Order"
                          maxLength={30}
                          required
                          min={1}
                          onChange={handleInputChange}
                        />
                      </Form.Group>
                    </div>
                  </Col>
                </Row>

                <div className="d-flex justify-content-between">
                  <Button
                    type="button"
                    variant="primary"
                    className="btn-info clearBtn"
                    onClick={() => {
                      setForm({
                        period_id: "",
                        category_id: "",
                        period_name: "",
                        start_time: "",
                        end_time: "",
                        period_order: "",
                      });
                      setEditId(null);
                    }}
                  >
                    Reset
                  </Button>

                  {canSubmit && (
                    <Button type="submit" variant="primary" className="btn-success primaryBtn">
                      {editId !== null ? "Update" : "Add"}
                    </Button>
                  )}
                </div>
              </form>
            </Card.Body>
          </Card>
        </Container>
      </section>

      <section>
        <div className="commonDataTableHead mt-1">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="d-flex align-items-center gap-2" />
            <div>
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                className="searchInput"
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="commonTable">
          <div className="tableBody">
            {isLoading ? (
              <div className="loadingContainer">
                <img src={loading} alt="Loading..." className="loadingGif" />
              </div>
            ) : (
              <AppDataGrid
                rows={filteredRecords}
                columns={columns}
                getRowId={(r) => r.period_id}
                showToolbar={false}
                pagination
                pageSizeOptions={[10, 20, 50]}
                density="compact"
                maxHeight={450}
              />
            )}
          </div>
        </div>
      </section>

      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)} className="commonFilterModal">
        <Modal.Header closeButton className="modalHeaderFixed">
          <Modal.Title>Filter</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyScrollable">
          <Row>
            <Col xs={12}>
              <div className="commonInput">
                <Form.Group controlId="period_name">
                  <Form.Label>Period Name</Form.Label>
                  <Form.Control
                    type="text"
                    value={form.period_name}
                    placeholder="Enter Period Name"
                    maxLength={30}
                    onChange={handleFilterInputChange}
                  />
                </Form.Group>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="modalFooterFixed">
          <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleFilterReset}>
            Reset
          </Button>

          <div>
            <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={() => setShowFilterModal(false)}>
              Cancel
            </Button>

            <Button variant="primary" className="btn-success primaryBtn" onClick={handleFilterSubmit}>
              Search
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Periods;
